import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, useLocation } from "react-router-dom";
import AdminNoticeForm from "../components/AdminNoticeForm";
import { root_url } from "../setting";
import { getBearerString } from "../utils/Auth";
import { dateString } from "./Notice";
const DashBoardResult = ({ history }) => {
  const [post, setPost] = useState({
    title: "",
    createTime: "",
    viewCount: "",
    content: "",
    passwd: "",
    size: "",
  });
  const [url, setURL] = useState({
    url: "",
    length: "",
    num: "",
    kind: "",
  });
  const [isAdmin, setIsAdmin] = useState(false);
  const [isPostPasswdExist, setIsPostPasswdExist] = useState(false);
  const [inputPasswd, setInputPasswd] = useState("");
  const [showAnswer, setShowAnswer] = useState(false);
  const { pathname } = useLocation();
  const [onUpdate, setOnUpdate] = useState(false);
  const [onUpdateAnswer, setOnUpdateAnswer] = useState(false);
  useEffect(() => {
    const url = window.location.href;
    const length = url.split("/").length;
    const num = url.split("/")[length - 1];
    const kind = url.split("/")[length - 2];
    // console.log(`num: ${num}, kind: ${kind}`);
    setURL({ url: url, length: length, num: num, kind: kind });
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${root_url}/api/${kind}/${num}`);
        console.log("postNo이 ", num, "인 글의 내용 ==> ", data);
        setPost(data);
        let { passwd } = data;
        if (passwd) setIsPostPasswdExist(true);
      } catch (e) {
        if (e?.response?.status === 403) {
          alert("권한이 존재하지 않습니다.");
          localStorage.setItem("accessToken", "");
          window.location.href = "/admin/login";
        }
        console.log(e);
        alert(
          "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
        );
      }
    };
    fetchData();
    if (pathname.startsWith("/admin")) {
      setIsAdmin(true);
    }
  }, []);
  return (
    <div>
      {onUpdate ? (
        <AdminNoticeForm
          method="put"
          dataObject={post}
          history={history}
          postNoForPut={post.postNo}
        />
      ) : onUpdateAnswer ? (
        <Container>
          <h1 className="pt-5 mb-5">
            {url.kind === "notice" ? "공지사항" : "Q&A"}
          </h1>
          <QnaPost history={history} post={post} method="put" />
        </Container>
      ) : isPostPasswdExist && !isAdmin ? (
        <Container>
          <h1 className="pt-5 mb-5">
            {url.kind === "notice" ? "공지사항" : "Q&A"}
          </h1>
          <input
            type="password"
            placeholder="비밀번호"
            onChange={(e) => {
              setInputPasswd(e.target.value);
            }}
          ></input>
          <input
            type="button"
            value={"입력"}
            onClick={() => {
              if (inputPasswd === post.passwd) setIsPostPasswdExist(false);
            }}
          />
        </Container>
      ) : (
        <Container>
          <h1 className="pt-5 mb-5">
            {url.kind === "notice" ? "공지사항" : "Q&A"}
          </h1>
          <h3 className="mb-4">{post.title}</h3>
          <Row className="mb-4 border-bottom">
            <Col xs={2} className="border-end">
              {post.author}
            </Col>
            <Col xs={3} className="border-end">
              {dateString(new Date(post.createTime))}
            </Col>
            <Col xs={2} className="border-end">
              조회 {`${post.viewCount === null ? "0" : post.viewCount + 1}`}
            </Col>
          </Row>
          {url.kind === "qna" ? (
            //qna 보여줄때
            <Container
              style={{
                minHeight: `${showAnswer ? "300px" : "500px"}`,
              }}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: post.content.replace(/(?:\r|\n|\r\n)/g, "<br />"),
                }}
              ></div>
            </Container>
          ) : (
            //notice 보여줄때
            <Container style={{ minHeight: "500px", overflowX: "scroll" }}>
              <div dangerouslySetInnerHTML={{ __html: post.content }}></div>
            </Container>
          )}
        </Container>
      )}

      <br />
      {!onUpdate && !onUpdateAnswer && (
        <Link
          to={
            isAdmin
              ? `/admin/board/${url.kind}?pageNo=1`
              : `/dashboard/${url.kind}?pageNo=1`
          }
          className="bg-custom-color border-0 p-2 rounded text-white"
        >
          목록으로
        </Link>
      )}
      <br />
      {/* Notice 수정 */}
      {isAdmin && url.kind === "notice" && !onUpdate && (
        <button
          className="bg-info button-in-class text-white mt-4"
          onClick={() => setOnUpdate(true)}
        >
          수정하기
        </button>
      )}
      {isAdmin && url.kind === "qna" && !showAnswer && post.indent === 1 && (
        <button
          className="bg-info button-in-class text-white mt-4"
          onClick={() => {
            if (post.indent === 1) {
              setShowAnswer(true);
            } else {
              alert("질문에만 답할 수 있습니다.");
            }
          }}
        >
          답변하기
        </button>
      )}
      {/* QNA 수정 */}
      {isAdmin &&
        url.kind === "qna" &&
        !showAnswer &&
        post.indent !== 1 &&
        !onUpdateAnswer && (
          <button
            className="bg-info button-in-class text-white mt-4"
            onClick={() => {
              // setShowAnswer(true);
              setOnUpdateAnswer(true);
            }}
          >
            수정하기
          </button>
        )}
      {isAdmin && url.kind === "qna" && showAnswer && (
        <div className="mt-4">
          <QnaPost history={history} post={post} />
        </div>
      )}
    </div>
  );
};

export default DashBoardResult;

const QnaPost = ({ history, post, method = "post" }) => {
  console.log(post);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    const { title, content } = data;
    const { articleId, indent, postNo } = post;
    let accessToken = getBearerString();
    axios({
      method,
      url: `${root_url}/api/admin/qna/answer`,
      data: {
        postNo,
        articleId,
        indent,
        title,
        mimeType: "text/plain",
        content,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          //data 올바르게 전송되면 qna 받아와야함
          // history.push(`/admin/board/qna/${data.articleId}`);
          history.push("/admin/board/qna?pageNo=1");
          return;
        }
      })
      .catch((e) => {
        console.log(e);
        if (e?.response?.status === 403) {
          alert("권한이 존재하지 않습니다.");
          localStorage.setItem("accessToken", "");
          window.location.href = "/admin/login";
        }
        if (e.response === undefined) {
          alert(
            "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
          );
        } else {
          alert(e.response.data.errorMessage);
        }
      });
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row className="p-2">
          <Col>
            <div className="form-floating">
              <input
                className="form-control"
                placeholder=" " //이래야 form-floating animation 적용됨
                type="text"
                defaultValue={`${method === "put" ? post.title : ""}`}
                {...register("title", { required: true })}
              ></input>
              <label>제목</label>
            </div>
          </Col>
        </Row>
        <div className="form-floating p-2">
          <textarea
            className="form-control h-25"
            defaultValue={`${method === "put" ? post.content : ""}`}
            placeholder=" "
            rows="10"
            maxLength="1000"
            style={{ resize: "none", overflowY: "hidden" }}
            {...register("content", { required: true })}
          ></textarea>
          <label>내용</label>
        </div>
        <button
          className="bg-info button-in-class text-white"
          onClick={handleSubmit}
        >
          답변완료
        </button>
      </form>
    </div>
  );
};
